import React from 'react';
import loadable from '@loadable/component';
import LoadingScreen from 'components/LoadingScreen';

const LoadableCreditPending = loadable(() => import('./CreditPending'), {
  fallback: <LoadingScreen />,
});

export default LoadableCreditPending;
